module.exports = __webpack_public_path__ + "img/logo-linkem-negative.371778aa.png";